import classNames from "classnames";
import { NumberFormat } from "@design-system/NumberFormat/NumberFormat";
import { ScheduleNumericInput } from "./ScheduleNumericInput";
import styles from "./ScheduleDrawer.module.scss";

interface SchedulePercentInputProps {
    value: number;
    /** A locked percent is shown but not typed: the row takes the remainder. */
    isLocked: boolean;
    onChange: (percent: number) => void;
    "aria-label": string;
}

/** An allocation percent field for a recognition or milestone row. */
export const SchedulePercentInput = ({
    value,
    isLocked,
    onChange,
    "aria-label": ariaLabel,
}: SchedulePercentInputProps) => (
    <NumberFormat
        value={value}
        onValueChange={
            isLocked
                ? undefined
                : (numberValues, sourceInfo) => {
                      // react-number-format also fires this when the value
                      // prop is rewritten programmatically; only user input
                      // carries a DOM event.
                      if (sourceInfo.event == null) {
                          return;
                      }
                      onChange(numberValues.floatValue ?? 0);
                  }
        }
        suffix="%"
        decimalScale={2}
        allowNegative={false}
        readOnly={isLocked}
        tabIndex={isLocked ? -1 : undefined}
        aria-label={ariaLabel}
        customInput={ScheduleNumericInput}
        className={classNames(
            styles.drawerInput,
            styles.numericInput,
            styles.percentInput,
        )}
    />
);
